/**
 * 计划性线索
 * 2017-11-9
 * Bai.Zhiming
 */
"use strict";
angular.module("plannedCluesModule", [
    "plannedCluesRouterModule", //计划性线索总路由
    "recentPolicyModule", //近期政策模块
    "todayInHistoryModule", //历史今天模块
    "recentMeetingModule", //近期会议
    "tracingMonitoringModule", //监测跟踪
]);